// TransectsDialog.js
import { useState } from "react"
import { Typography } from '@mui/material'
import TransectsForm from './TransectsForm'
import TransectsPropertiesForm from './TransectsPropertiesForm'
import { TransectChartjs } from './TransectChartjs'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @param {function} setNewName Sets the new name of this object if the user modifies the name.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {function} setFullModel Sets the full model in case of any updates.
 * @returns UI for interactive swmm modeling.
 */

export default function TransectsDialog({ model, setModel, targetType, target, setNewName, fullModel, setFullModel }) {
  const [newTargetName, setNewTargetName] = useState(target)
  
  const saveEdits = (data) => {
    setFullModel(prev => ({
      ...prev,
      TRANSECTS:{
        ...prev.TRANSECTS, 
        [target]: {
          ...model.TRANSECTS[target], GR: [...data], Nsta: data.length 
        }
      }
    }))
  }

  function handleChange(e) {
    setNewName(e.target.value)
    setNewTargetName(e.target.value)
  }

  function openTab(evt, tabName) {
    var i, tabcontent, tablinks
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent")
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none"
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks")
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "")
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block"
    evt.currentTarget.className += " active"
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(model){
    return(
      <>
      {
        <div style={{ flex:1, height:'100%', backgroundColor:'black'}} >
          <Typography id="modal-modal-title" variant="p4" >

            <div style={{display:"flex", flexFlow: "column", padding: '10px'}}>
              <label>Transect Name</label>
              <input style={{fontSize: '16px', background: 'rgb(50, 50, 50)', color: 'lightskyblue', border: 'none', textAlign: 'center'}} type="text" value={newTargetName} onChange={handleChange} />
            </div>
            {
            <div style={{display:"flex", minHeight: '80px', height: 'calc(100% - 550px)'}}>
              <TransectChartjs 
                out_data={(fullModel && fullModel.TRANSECTS && fullModel.TRANSECTS[target] && fullModel.TRANSECTS[target].GR)?fullModel.TRANSECTS:[]} 
                model={fullModel}
                targets={[target]} 
                titleText={`Transect profile`} />
            </div>
            }
            <div style={{height: "280px", background:'black', overflowY: 'hidden', paddingBottom:"120px"}}>
              {
                <>
                <div className="tab">
                  <button className="tablinks active" onClick={(e)=>openTab(e, 'Properties' )}>Properties</button>
                  <button className="tablinks" onClick={(e)=>openTab(e, 'Stations' )}>Stations</button>
                </div>
                
                <div id="Properties" style={{display: 'block'}} className="tabcontent">
                  <div style={{display:"flex", minHeight: '80px', height: '305px'}}>
                    {
                      targetType && 
                      targetType in model && 
                      target &&
                      <TransectsPropertiesForm model={model} target={target} setModel={setModel} setFullModel={setFullModel} />
                    }
                  </div>
                </div>
                
                <div id="Stations" className="tabcontent">
                  <div style={{display:"flex", minHeight: '80px', height: '380px'}}>
                    {
                      targetType && 
                      targetType in model && 
                      target &&
                      <TransectsForm model={model} target={target} targetType={'TRANSECTS'} saveEdits={saveEdits} />
                    }
                  </div>
                </div>
                
                </>
              }
            </div>
          
          </Typography>
        </div>
      }
      </>
    )
  } else {
    return null
  }
}